import React, { useRef, useEffect, useState } from 'react';
var InView = function (_a) {
    var children = _a.children, _b = _a.parent, parent = _b === void 0 ? undefined : _b, setElementInView = _a.setElementInView, _c = _a.position, position = _c === void 0 ? 0 : _c, _d = _a.withRootMargin, withRootMargin = _d === void 0 ? true : _d, _e = _a.threshold, threshold = _e === void 0 ? [0, 0.6] : _e, _f = _a.isLazy, isLazy = _f === void 0 ? true : _f;
    var inViewRef = useRef(null);
    var _g = useState(!isLazy), shouldLoad = _g[0], setShouldLoad = _g[1];
    /**
     * Handles children that are scrolled into the viewport
     * @param {IntersectionObserverEntry} entries - An array of elements being detected
     * @param {IntersectionObserver} observer - The IntersectionObserver instance
     */
    var handleIntersect = function (entries) {
        entries.forEach(function (entry) {
            var intersectionRatio = entry.intersectionRatio;
            if (intersectionRatio > 0) {
                setShouldLoad(true);
            }
            if (intersectionRatio > threshold[threshold.length - 1]) {
                setElementInView(position, true);
            }
            else {
                setElementInView(position, false);
            }
        });
    };
    useEffect(function () {
        var element = inViewRef.current;
        if (window && window.IntersectionObserver) {
            var opts = {
                root: parent || document.body,
                // Preload when ~100px from root.
                rootMargin: withRootMargin ? '100px' : '0px',
                threshold: threshold
            };
            var observer_1 = new IntersectionObserver(handleIntersect, opts);
            observer_1.observe(element);
            // clean up our subscriptions
            return function () { return observer_1.unobserve(element); };
        }
    }, [parent]);
    return React.createElement("div", { ref: inViewRef }, shouldLoad && children);
};
export default InView;
